import InputMonth from "@/components/Input/InputMonth";
import InputYear from "@/components/Input/InputYear";
import type React from "react";

type YearMonthPickerProps = {
  currentMonth: Date;
  onYearSelect: (year: number) => void;
  onMonthSelect: (month: number) => void;
};

/**
 * 年月選択用のコンポーネント
 * InputYearとInputMonthを組み合わせて年月の選択を行う
 */
export const YearMonthPicker: React.FC<YearMonthPickerProps> = ({
  currentMonth,
  onYearSelect,
  onMonthSelect,
}) => (
  <div className="flex gap-2">
    <InputYear
      value={currentMonth.getFullYear().toString()}
      onChange={(year: string) => onYearSelect(parseInt(year))}
      className="flex-1"
    />
    <InputMonth
      value={(currentMonth.getMonth() + 1).toString()}
      onChange={(month: string) => onMonthSelect(parseInt(month) - 1)}
      className="flex-1"
    />
  </div>
);
